/** @format */

import {useState} from 'react';

import {TableVirtualized} from 'components/Table';
import {TanStackTableData} from 'components/Table/core/types';

import {ModalSimple} from 'components/ModalSimple';

import {useSnackbar} from 'components/SnackbarNew';

import {ReportsContainer, ThanksBox, ThanksHeadingText, ThanksText} from './styles';
import {formatColumns} from './helpers/formatColumns';
import {TABLE_HEIGHT} from './constants';
import {FeedbackForm} from './components/FeedbackForm';

interface BriefReportsProps {
  data: TanStackTableData[];
  onReportView?: (reportId: string) => void;
}

const BriefReports = ({data, onReportView}: BriefReportsProps) => {
  const [openFeedbackForm, setOpenFeedbackForm] = useState<boolean>(false);
  const [aiReportId, setAiReportId] = useState<string | null>(null);
  const [aiReportName, setAiReportName] = useState<string>('');

  const {showSnack, Snack} = useSnackbar({variant: 'success'});

  const handleOpen = (id: string, reportName: string) => {
    setAiReportId(id);
    setAiReportName(reportName);
    setOpenFeedbackForm(true);
  };

  const handleClose = () => {
    setAiReportId(null);
    setAiReportName('');
    setOpenFeedbackForm(false);
  };

  const handleSuccess = () => {
    showSnack(
      <ThanksBox>
        <ThanksHeadingText>Спасибо</ThanksHeadingText>
        <ThanksText>Мы получили вашу оценку</ThanksText>
      </ThanksBox>,
    );
    handleClose();
  };

  return (
    <ReportsContainer>
      <TableVirtualized
        columns={formatColumns(handleOpen, onReportView)}
        data={data}
        defaultSortBy='reportName'
        defaultOrderBy='asc'
        tableHeight={TABLE_HEIGHT}
      />

      <ModalSimple
        isOpen={openFeedbackForm}
        onClose={handleClose}
        headerText='Оценка отчета'
        subHeaderText={aiReportName}
      >
        <FeedbackForm onCancel={handleClose} aiReportId={aiReportId} onSuccess={handleSuccess} />
      </ModalSimple>

      <Snack />
    </ReportsContainer>
  );
};

export default BriefReports;
